jQuery(function ($) {
    var $w = $(window);

    var $header = $('#site-header');
    var $container = $header.find('.header-container');

    var $pageMenu = $('#page-menu');
    if (!$pageMenu.length) return;

    var $ul = $pageMenu.find('ul').first();
    if (!$ul.length) return;

    var $links = $pageMenu.find('a[href^="#"]:not([href="#"])');
    if (!$links.length) return;

    var sections = [];
    var activeId = null;

    var $indicator = $();
    var ticking = false;

    // Click-scroll lock + settle
    var pendingId = null;

    var settleRAF = 0;
    var settleStillFrames = 0;
    var settleLastY = null;

    // Short freeze window after settle to avoid a one-frame flip
    var freezeUntil = 0;

    var ACTIVE_BUFFER = 28;
    var GAP = 12;

    function prefersReducedMotion() {
        return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function elemHeight(el) {
        if (!el) return 0;
        var rect = el.getBoundingClientRect();
        return Math.max(0, rect.height || 0);
    }

    function getFixedHeaderBottomPx() {
        if (!$container.length) return 0;

        if ($container.hasClass('offscreen')) {
            return Math.max(0, $container[0].getBoundingClientRect().bottom || 0);
        }

        return Math.max(0, $container[0].getBoundingClientRect().height || 0);
    }

    function getSecondaryMenuHeightPx() {
        return elemHeight($pageMenu[0]);
    }

    function getScrollOffsetPx() {
        return getFixedHeaderBottomPx() + getSecondaryMenuHeightPx() + GAP;
    }

    function ensureIndicator() {
        if ($indicator.length) return;

        $indicator = $('<span class="page-menu-indicator" aria-hidden="true"></span>');
        $ul.append($indicator);

        $indicator.css('transition', prefersReducedMotion() ? 'none' : 'transform 350ms ease, width 350ms ease');
    }

    function getLinkMetrics($link) {
        if (!$link || !$link.length) return null;

        var linkRect = $link[0].getBoundingClientRect();
        var ulRect = $ul[0].getBoundingClientRect();

        // Sub-pixel accurate (prevents desktop jitter)
        var left = (linkRect.left - ulRect.left) + $ul[0].scrollLeft;
        var width = linkRect.width;

        return { left: left, width: width };
    }

    function moveIndicatorToLink($link, animate) {
        ensureIndicator();
        if (!$indicator.length || !$link || !$link.length) return;

        var m = getLinkMetrics($link);
        if (!m) return;

        var doAnimate = (animate !== false) && !prefersReducedMotion();
        $indicator.css('transition', doAnimate ? 'transform 350ms ease, width 350ms ease' : 'none');

        $indicator.css({
            width: m.width + 'px',
            transform: 'translateX(' + m.left + 'px)'
        });

        if (!doAnimate && !prefersReducedMotion()) {
            requestAnimationFrame(function () {
                $indicator.css('transition', 'transform 350ms ease, width 350ms ease');
            });
        }
    }

    function keepLinkInView($link, mode) {
        // mode: 'auto' | 'smooth'
        if (!$link || !$link.length) return;

        var ulEl = $ul[0];
        var ulRect = ulEl.getBoundingClientRect();
        var linkRect = $link[0].getBoundingClientRect();

        if (linkRect.left >= ulRect.left && linkRect.right <= ulRect.right) return;

        var PADDING = 24;
        var leftInUl = (linkRect.left - ulRect.left) + ulEl.scrollLeft;
        var targetLeft = Math.max(0, leftInUl - PADDING);

        ulEl.scrollTo({
            left: targetLeft,
            behavior: (mode === 'smooth' && !prefersReducedMotion()) ? 'smooth' : 'auto'
        });
    }

    function clearCurrent() {
        $pageMenu.find('.is-current').removeClass('is-current').removeAttr('aria-current');
    }

    function setCurrent(id, animateIndicator, keepMode) {
        if (!id || id === activeId) return;

        activeId = id;
        clearCurrent();

        var $match = $();

        $links.each(function () {
            var href = this.getAttribute('href');
            if (!href || href.charAt(0) !== '#') return;

            if (href.slice(1) === id) {
                $match = $(this);
                $match.addClass('is-current').attr('aria-current', 'page');
                $match.closest('li').addClass('is-current');
            }
        });

        if ($match.length) {
            if (keepMode) keepLinkInView($match, keepMode);
            moveIndicatorToLink($match, animateIndicator !== false);
        }
    }

    function mapSections() {
        sections = [];

        $links.each(function () {
            var href = this.getAttribute('href');
            if (!href || href.charAt(0) !== '#') return;

            var id = href.slice(1);
            if (!id) return;

            var el = document.getElementById(id);
            if (!el) return;

            sections.push({ id: id, el: el });
        });

        var seen = {};
        sections = sections.filter(function (s) {
            if (seen[s.id]) return false;
            seen[s.id] = true;
            return true;
        });
    }

    function findActiveSectionId() {
        if (!sections.length) return null;

        var activeLine = getScrollOffsetPx();
        var threshold = activeLine + ACTIVE_BUFFER;

        var bestId = null;
        var bestTop = -Infinity;

        for (var i = 0; i < sections.length; i++) {
            var top = sections[i].el.getBoundingClientRect().top;

            if (top <= threshold && top > bestTop) {
                bestTop = top;
                bestId = sections[i].id;
            }
        }

        if (!bestId && sections.length) bestId = sections[0].id;

        return bestId;
    }

    function cancelSettle() {
        if (settleRAF) {
            cancelAnimationFrame(settleRAF);
            settleRAF = 0;
        }
        settleStillFrames = 0;
        settleLastY = null;
    }

    function startSettle() {
        cancelSettle();
        if (!pendingId) return;

        function tick() {
            if (!pendingId) {
                cancelSettle();
                return;
            }

            var y = window.pageYOffset || document.documentElement.scrollTop || 0;

            if (settleLastY === null) {
                settleLastY = y;
                settleStillFrames = 0;
            } else {
                if (Math.abs(y - settleLastY) <= 1) settleStillFrames++;
                else settleStillFrames = 0;

                settleLastY = y;
            }

            // After a few still frames, do one final alignment correction.
            if (settleStillFrames >= 3) {
                var el = document.getElementById(pendingId);
                if (el) {
                    var activeLine = getScrollOffsetPx();
                    var top = el.getBoundingClientRect().top;
                    var delta = top - activeLine;

                    // Correct only if meaningfully off; allow buffer to handle the rest.
                    if (Math.abs(delta) >= 2) {
                        window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
                    }
                }

                pendingId = null;
                cancelSettle();

                // Freeze briefly to avoid a flip during late header/menu settling
                freezeUntil = Date.now() + 180;

                requestAnimationFrame(function () {
                    update();
                });

                return;
            }

            settleRAF = requestAnimationFrame(tick);
        }

        settleRAF = requestAnimationFrame(tick);
    }

    function update() {
        ticking = false;

        // During click-scroll, keep clicked item current; settle releases it.
        if (pendingId) {
            setCurrent(pendingId, true, 'smooth');
            return;
        }

        // Brief freeze after settle prevents a one-frame revert
        if (Date.now() < freezeUntil) {
            if (activeId) setCurrent(activeId, false, 'auto');
            return;
        }

        var id = findActiveSectionId();
        if (id) setCurrent(id, true, 'auto');
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    function scrollToId(id) {
        var el = document.getElementById(id);
        if (!el) return;

        var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
        var targetTop = currentY + el.getBoundingClientRect().top;
        var y = Math.max(0, targetTop - getScrollOffsetPx());

        window.scrollTo({
            top: y,
            behavior: prefersReducedMotion() ? 'auto' : 'smooth'
        });

        if (history && history.pushState) {
            history.pushState(null, '', '#' + id);
        } else {
            window.location.hash = id;
        }
    }

    function syncIndicatorToCurrent(animate) {
        var $current = $pageMenu.find('a.is-current').first();
        if ($current.length) {
            keepLinkInView($current, 'auto');
            moveIndicatorToLink($current, animate === false ? false : true);
        }
    }

    $pageMenu.on('click', 'a[href^="#"]:not([href="#"])', function (e) {
        var href = this.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var id = href.slice(1);
        if (!id) return;

        if (!document.getElementById(id)) return;

        e.preventDefault();

        cancelSettle();
        freezeUntil = 0;
        pendingId = id;

        var $link = $(this);

        keepLinkInView($link, 'smooth');
        setCurrent(id, true, null);
        moveIndicatorToLink($link, true);

        scrollToId(id);
        startSettle();
    });

    function init() {
        ensureIndicator();
        mapSections();

        var initialId = findActiveSectionId();
        if (initialId) setCurrent(initialId, false, 'auto');
        else syncIndicatorToCurrent(false);

        requestAnimationFrame(function () {
            syncIndicatorToCurrent(false);
        });
    }

    init();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });

    var resizeTimer;
    function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            init();
            requestAnimationFrame(function () {
                syncIndicatorToCurrent(false);
                update();
            });
        }, 120);
    }

    $w.on('resize orientationchange', onResize);

    $w.on('header:remeasure', function () {
        init();
        requestAnimationFrame(function () {
            syncIndicatorToCurrent(false);
            update();
        });
    });
});
